import * as Yup from "yup";
import { contextosCobrancaComDias } from "../../resources/constantes";

const mensagemPersonalizadaValidator = Yup.object().shape({
  contexto: Yup.string().required("Contexto"),
  mensagem: Yup.string().required("Mensagem"),
  variaveis: Yup.array().of(Yup.string()).nullable().optional(),
  ativado: Yup.boolean().nullable().optional(),
  diasAntecedencia: Yup.number()
    .nullable()
    .notRequired()
    .min(0, "Dias de antecedência")
    .max(365, "Dias de antecedência")
    .when("contexto", {
      is: (contexto) => contextosCobrancaComDias.includes(contexto),
      then: (schema) => schema.min(1, "Dias"),
    }),
  horaEnvio: Yup.string()
    .nullable()
    .notRequired()
    .test("apos-3-horas", "Hora após as 03:00", (value) => {
      if (!value) return true;
      const [hora, min] = value.split(":").map(Number);
      const minutos = hora * 60 + min;
      return minutos > 180;
    }),
});

export default mensagemPersonalizadaValidator;
